// extracted by mini-css-extract-plugin
module.exports = {"suffix":"Base_suffix__3j9lY","inputGroup":"Base_inputGroup__BHUAZ"};